import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import SingleCheckbox from '../../common/SingleCheckbox';

const SingleCheckboxComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Single Checkbox Showcase</h2>

                        {/* First Row */}
                        {/* <Row className="mb-4">
                            <Col lg={6}>
                                <SingleCheckbox
                                    label="I agree to the terms and conditions"
                                    required={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SingleCheckbox
    label="I agree to the terms and conditions"
    required={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row> */}

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SingleCheckbox
                                    label="I have read the privacy policy"
                                    required={true}
                                    showHelp={true}
                                    helpText="Please read the policy before agreeing."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SingleCheckbox
    label="I have read the privacy policy"
    required={true}
    showHelp={true}
    helpText="Please read the policy before agreeing."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SingleCheckbox
                                    label="Subscribe to newsletter"
                                    required={true}
                                    customError="Please agree to subscribe."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SingleCheckbox
    label="Subscribe to newsletter"
    required={true}
    customError="Please agree to subscribe."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SingleCheckbox
                                    label="I consent to data processing"
                                    layout="right"
                                    required={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SingleCheckbox
    label="I consent to data processing"
    layout="right"
    required={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fifth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <SingleCheckbox
                                    label="I accept cookies"
                                    color="lightgreen"
                                    required={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<SingleCheckbox
    label="I accept cookies"
    color="lightgreen"
    required={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default SingleCheckboxComponent;
